import React from "react";
import { object, bool } from "prop-types";
import { getStoryHeading } from "../../../helper/utils";
import "./story-headline.m.css";
import { Link } from "@quintype/components";

const StoryHeadline = ({ story = {}, aboveHeroImage = false }) => {
  return (
    <Link href={`/${story.slug}`}>
      <h2 styleName={aboveHeroImage ? "headlineWithPosition" : "headline"}>{getStoryHeading(story)}</h2>{" "}
    </Link>
  );
};

StoryHeadline.propTypes = {
  story: object,
  aboveHeroImage: bool
};

export default StoryHeadline;
